import { FaPencilRuler, FaLaptopCode, FaCogs, FaClipboardList } from 'react-icons/fa';

const WorkProcess = () => {
  const processes = [
    {
      step: '01',
      title: 'Planning',
      icon: FaClipboardList,
      description: 'We analyze your requirements and create a detailed project roadmap',
      bgColor: 'bg-gradient-to-br from-orange-500 to-red-500',
      borderColor: 'border-orange-400',
    },
    {
      step: '02',
      title: 'Design',
      icon: FaPencilRuler,
      description: 'Our team crafts intuitive and engaging user experiences',
      bgColor: 'bg-gradient-to-br from-blue-500 to-blue-600',
      borderColor: 'border-blue-400',
    },
    {
      step: '03',
      title: 'Development',
      icon: FaCogs,
      description: 'We build robust solutions using cutting-edge technologies',
      bgColor: 'bg-gradient-to-br from-purple-500 to-purple-600',
      borderColor: 'border-purple-400',
    },
    {
      step: '04',
      title: 'Launch',
      icon: FaLaptopCode,
      description: 'We deploy and ensure everything runs smoothly in production',
      bgColor: 'bg-gradient-to-br from-green-500 to-teal-500',
      borderColor: 'border-green-400',
    }
  ];

  return (
    <section className="section-padding bg-gray-50 font-opensans relative overflow-hidden">
      {/* Black Connected Boxes Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23000000' stroke-width='1' stroke-opacity='0.8'%3E%3Crect x='10' y='10' width='15' height='15' fill='%23000000' fill-opacity='0.1'/%3E%3Crect x='55' y='10' width='15' height='15' fill='%23000000' fill-opacity='0.1'/%3E%3Crect x='10' y='55' width='15' height='15' fill='%23000000' fill-opacity='0.1'/%3E%3Crect x='55' y='55' width='15' height='15' fill='%23000000' fill-opacity='0.1'/%3E%3Cline x1='25' y1='17.5' x2='55' y2='17.5'/%3E%3Cline x1='17.5' y1='25' x2='17.5' y2='55'/%3E%3Cline x1='62.5' y1='25' x2='62.5' y2='55'/%3E%3Cline x1='25' y1='62.5' x2='55' y2='62.5'/%3E%3Cline x1='25' y1='17.5' x2='17.5' y2='25'/%3E%3Cline x1='55' y1='17.5' x2='62.5' y2='25'/%3E%3Cline x1='17.5' y1='55' x2='25' y2='62.5'/%3E%3Cline x1='62.5' y1='55' x2='55' y2='62.5'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '80px 80px'
        }}></div>
      </div>

      {/* Additional Black Dotted Pattern */}
      <div className="absolute inset-0 opacity-8 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.6'%3E%3Ccircle cx='5' cy='5' r='1'/%3E%3Ccircle cx='15' cy='5' r='1'/%3E%3Ccircle cx='25' cy='5' r='1'/%3E%3Ccircle cx='35' cy='5' r='1'/%3E%3Ccircle cx='5' cy='15' r='1'/%3E%3Ccircle cx='15' cy='15' r='1'/%3E%3Ccircle cx='25' cy='15' r='1'/%3E%3Ccircle cx='35' cy='15' r='1'/%3E%3Ccircle cx='5' cy='25' r='1'/%3E%3Ccircle cx='15' cy='25' r='1'/%3E%3Ccircle cx='25' cy='25' r='1'/%3E%3Ccircle cx='35' cy='25' r='1'/%3E%3Ccircle cx='5' cy='35' r='1'/%3E%3Ccircle cx='15' cy='35' r='1'/%3E%3Ccircle cx='25' cy='35' r='1'/%3E%3Ccircle cx='35' cy='35' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          {/* Modern Line Icons + Title - Centered like Services */}
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-[#106bcb]"></div>
            <span className="text-[#22446b] text-sm font-semibold uppercase tracking-wider">Working Process</span>
            <div className="w-12 h-0.5 bg-[#106bcb]"></div>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-rajdhani font-bold text-[#22446b] leading-tight max-w-4xl mx-auto mb-6">
            Process we follow
          </h2>
        </div>

        {/* Process Flow - Desktop */}
        <div className="hidden lg:block">
          <div className="relative max-w-7xl mx-auto">
            {/* Main Connection Line */}
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-300 transform -translate-y-1/2 z-10"></div>
            
            {/* Process Steps */}
            <div className="relative z-20 flex items-center justify-between">
              {processes.map((process, index) => (
                <div key={index} className="relative group">
                  {/* Step Connection Point - Behind Card */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 rounded-full border-4 border-white shadow-lg z-10" style={{
                    backgroundColor: process.bgColor.includes('orange') ? '#f97316' : 
                                    process.bgColor.includes('blue') ? '#3b82f6' : 
                                    process.bgColor.includes('purple') ? '#8b5cf6' : '#10b981'
                  }}></div>

                  {/* Arrow to Next Step */}
                  {index < processes.length - 1 && (
                    <div className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-1/2 z-15">
                      <div className="w-0 h-0" style={{
                        borderLeft: `12px solid ${process.bgColor.includes('orange') ? '#fb923c' : 
                                                 process.bgColor.includes('blue') ? '#60a5fa' : 
                                                 process.bgColor.includes('purple') ? '#a78bfa' : '#34d399'}`,
                        borderTop: '8px solid transparent',
                        borderBottom: '8px solid transparent'
                      }}></div>
                    </div>
                  )}
                  
                  {/* Process Card - Above Connection Point */}
                  <div className={`${process.bgColor} rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 relative w-[240px] min-h-[240px] max-h-[280px] flex flex-col items-center justify-start text-center group hover:scale-105 hover:-translate-y-2 overflow-hidden z-20`}>
                    {/* Icon */}
                    <div className="mb-3 mt-2 flex-shrink-0">
                      <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                        <process.icon className="text-3xl transition-colors duration-300" style={{
                          color: process.bgColor.includes('orange') ? '#f97316' : 
                                 process.bgColor.includes('blue') ? '#3b82f6' : 
                                 process.bgColor.includes('purple') ? '#8b5cf6' : '#10b981'
                        }} />
                      </div>
                    </div>
                    
                    {/* Content */}
                    <h3 className="text-lg font-rajdhani font-bold text-white mb-2 group-hover:text-gray-100 transition-colors duration-300 flex-shrink-0">
                      {process.title}
                    </h3>
                    <p className="text-white/90 text-xs leading-relaxed px-3 group-hover:text-white transition-colors duration-300 overflow-hidden">
                      {process.description}
                    </p>

                    {/* Decorative Elements */}
                    <div className="absolute top-4 right-4 w-8 h-8 border-2 border-white/20 rounded-full flex items-center justify-center">
                      <div className="w-2 h-2 bg-white/40 rounded-full"></div>
                    </div>
                  </div>

                  {/* Step Label Below */}
                  <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2 text-center">
                    <div className="text-gray-500 text-xs mt-1">{process.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Process Flow - Mobile/Tablet */}
        <div className="lg:hidden">
          <div className="max-w-md mx-auto">
            {processes.map((process, index) => (
              <div key={index} className="relative mb-16">
                {/* Step Connection Line */}
                {index < processes.length - 1 && (
                  <div className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-full z-20">
                    <div className="flex flex-col items-center">
                      {/* Connection Dot */}
                      <div className="w-4 h-4 rounded-full border-2 border-white shadow-md mb-2" style={{
                        backgroundColor: process.bgColor.includes('orange') ? '#f97316' : 
                                        process.bgColor.includes('blue') ? '#3b82f6' : 
                                        process.bgColor.includes('purple') ? '#8b5cf6' : '#10b981'
                      }}></div>
                      
                      {/* Vertical Line */}
                      <div className="w-0.5 h-8" style={{
                        backgroundColor: process.bgColor.includes('orange') ? '#fb923c' : 
                                        process.bgColor.includes('blue') ? '#60a5fa' : 
                                        process.bgColor.includes('purple') ? '#a78bfa' : '#34d399'
                      }}></div>
                      
                      {/* Arrow Down */}
                      <div className="w-0 h-0" style={{
                        borderTop: `8px solid ${process.bgColor.includes('orange') ? '#fb923c' : 
                                               process.bgColor.includes('blue') ? '#60a5fa' : 
                                               process.bgColor.includes('purple') ? '#a78bfa' : '#34d399'}`,
                        borderLeft: '5px solid transparent',
                        borderRight: '5px solid transparent'
                      }}></div>
                    </div>
                  </div>
                )}
                
                {/* Process Card */}
                <div className={`${process.bgColor} rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 relative min-h-[240px] max-h-[280px] flex flex-col items-center justify-start text-center group hover:scale-105 overflow-hidden`}>
                  {/* Step Number Badge */}
                  <div className="absolute top-4 left-4 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg z-30 border-4 border-white shadow-lg" style={{
                    backgroundColor: process.bgColor.includes('orange') ? '#f97316' : 
                                    process.bgColor.includes('blue') ? '#3b82f6' : 
                                    process.bgColor.includes('purple') ? '#8b5cf6' : '#10b981'
                  }}>
                    {process.step}
                  </div>
                  
                  {/* Icon */}
                  <div className="mb-3 mt-2 flex-shrink-0">
                    <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                      <process.icon className="text-3xl transition-colors duration-300" style={{
                        color: process.bgColor.includes('orange') ? '#f97316' : 
                               process.bgColor.includes('blue') ? '#3b82f6' : 
                               process.bgColor.includes('purple') ? '#8b5cf6' : '#10b981'
                      }} />
                    </div>
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-rajdhani font-bold text-white mb-2 group-hover:text-gray-100 transition-colors duration-300 flex-shrink-0">
                    {process.title}
                  </h3>
                  <p className="text-white/90 text-sm leading-relaxed px-2 group-hover:text-white transition-colors duration-300 overflow-hidden">
                    {process.description}
                  </p>

                  {/* Decorative Elements */}
                  <div className="absolute top-4 right-4 w-8 h-8 border-2 border-white/20 rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-white/40 rounded-full"></div>
                  </div>
                </div>

                {/* Step Label */}
                <div className="text-center mt-4">
                  <div className="text-gray-500 text-xs mt-1">{process.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;